export const REACT_API_URL = "https://newsportal-serverapi.herokuapp.com/api";
